import { IStackItemStyles } from '@fluentui/react';
import { IPStack, IPText } from 'baseComponents';
import { KPIContext } from 'components/KPI/KPIContext';
import { globalTextStylesBold } from 'globalStyles';
import { Integration } from 'models/integrations/integration';

export const onRenderIntegrationContext = (item: Integration) => {
  return (
    <IPStack verticalFill styles={{ root: { width: 400, height: 400, padding: 20, overflowX: 'hidden' } }}>
      <KPIContext kpi={item.kpi} readOnly />
    </IPStack>
  );
};

interface IStatBoxProps {
  id?: string;
  text: string | number | undefined;
  bold?: boolean;
  styles: IStackItemStyles;
  onClick?: (() => void) | undefined;
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
}

export const StatBox = (props: IStatBoxProps) => {
  return (
    <IPStack
      tabIndex={0}
      id={props.id}
      styles={props.styles}
      onClick={props.onClick}
      onMouseEnter={props.onMouseEnter}
      onMouseLeave={props.onMouseLeave}
      horizontalAlign="center"
      verticalAlign="center"
    >
      <IPText styles={props.bold ? globalTextStylesBold : undefined}>{props.text?.toString()}</IPText>
    </IPStack>
  );
};
